<template lang="pug">
  DefaultLayout
    CommonSection(title="Уведомления")
      FormBlock(mobile)
        NotificationList
</template>

<script>
import DefaultLayout from '@/layouts/Default.vue';
import CommonSection from '@/components/CommonSection.vue';
import NotificationList from '@/components/notification/NotificationList.vue';
import FormBlock from '@/components/FormBlock.vue';

export default {
  name: 'NotificationsPage',
  components: {
    FormBlock,
    DefaultLayout,
    CommonSection,
    NotificationList,
  },
};
</script>
